import {Image} from '@shopify/hydrogen';
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share';
import FacebookIconImage from '../assets/image/icons/icon-fb-w.svg';
import LinkedinIconImage from '../assets/image/icons/icon-linkedin-w.svg';
import TwiterIconImage from '../assets/image/icons/icon-twitter-w.svg';
import GmailIconImage from '../assets/image/icons/icon-google-w.svg';

export default function SocialShare({url, page}) {
  let shareUrl;
  if (typeof window !== 'undefined') {
    shareUrl = url ? url : window.location.href;
  }

  const handleDatalayer = (socialNetwork) => {
    dataLayer.push({
      event: 'share', //Static data
      method: socialNetwork, //Dynamic data
      content_type: 'Blog', //Dynamic data
      item_id : page._id, //Dynamic data
    });
  };

  return (
    <>
      <div className="grid gap-3 grid-cols-4 item-center blog-social-btns">
        <FacebookShareButton
          url={shareUrl}
          onClick={() => handleDatalayer('facebook')}
        >
          <Image src={FacebookIconImage} height={24} width={24} />
        </FacebookShareButton>
        <LinkedinShareButton
          url={shareUrl}
          onClick={() => handleDatalayer('linkedin')}
        >
          <Image src={LinkedinIconImage} height={24} width={24} />
        </LinkedinShareButton>
        <EmailShareButton
          url={shareUrl}
          onClick={() => handleDatalayer('email')}
        >
          <Image src={GmailIconImage} height={24} width={24} />
        </EmailShareButton>
        <TwitterShareButton
          url={shareUrl}
          onClick={() => handleDatalayer('twitter')}
        >
          <Image src={TwiterIconImage} height={24} width={24} />
        </TwitterShareButton>
      </div>
    </>
  );
}
